"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.modifierMaximumLength = void 0;
var isTypeString_1 = require("../../typeGuards/isTypeString");
var modifierMaximumLength = function (value, maximumLength) {
    if (!isTypeString_1.isTypeString(value)) {
        console.log("UseForm: value must be a string to be modified by modifierToUpperCase");
        return value;
    }
    if (value.length <= maximumLength) {
        return value;
    }
    return value.substring(0, maximumLength);
};
exports.modifierMaximumLength = modifierMaximumLength;
//# sourceMappingURL=modifierMaximumLength.js.map